var SwiperEtape = {
    init:function(){
        var swiper = new Swiper(".slider-blocks-lightgrey .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: 20,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
              },
            breakpoints: {
                
                1040: {
                    spaceBetween: 45,
                }
              }
          });
    }
}

$(window).load(function(){
    if($('.slider-blocks-lightgrey').length){
        SwiperEtape.init();
    }
})